<template>
  <b-taginput v-model="data" icon="tag" placeholder="Enter value" />
</template>

<script>
export default {
  name: 'c-tag-input',
  props: ['value'],
  computed: {
    data: {
      get() {
        const value = Array.isArray(this.value) ? this.value : []
        return value.map(v => v.data)
      },
      set(value) {
        this.$emit('input', value.map(v => ({ data: v })))
      },
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/lib/components/TagInput.vue